import { createAction, props } from '@ngrx/store';

import { ErrorInterface } from '../../interfaces/general.interface';
import {
  AuthUserEntityInterface,
  ChangePasswordInterface,
  ForgotPasswordInterface,
  RegisterInterface,
} from '../../interfaces/auth.interface';

enum AuthActionType {
  AuthInit = '[Auth] Init Auth',
  AuthInitSet = '[Auth] Init Auth SET',
  RefreshTokenLoading = '[Auth] Refresh Token',
  ForgotPassword = '[Auth] Forgot Password',
  ForgotPasswordSuccess = '[Auth] Forgot Password Success',
  errorClear = '[Auth] Error Clear',
  ForgotPasswordFailure = '[Auth] Forgot Password Failure',
  LogoutLoading = '[Auth] Logout',
  DeleteCookiesLoading = '[Auth] Delete Cookies',
  DeleteCookiesRedirect = '[Auth] Delete Cookies Redirect',
  DeleteCookiesSuccessLoading = '[Auth] Delete Cookies Success',
  RequestSuccess = '[Auth] Request Success',
  RegisterLoading = '[Auth] Register Loading',
  RegisterSuccess = '[Auth] Register Success',
  RegisterFailed = '[Auth] Register Failure',
}

export const logout = createAction(AuthActionType.LogoutLoading);

export const refreshTokenLoading = createAction(
  AuthActionType.RefreshTokenLoading,
  props<{ refreshToken: string }>()
);

export const DeleteCookiesLoading = createAction(
  AuthActionType.DeleteCookiesLoading,
  props<{ admin?: boolean }>()
);

export const DeleteCookiesRedirect = createAction(
  AuthActionType.DeleteCookiesRedirect,
  props<{ admin?: boolean }>()
);

export const DeleteCookiesSuccessLoading = createAction(
  AuthActionType.DeleteCookiesSuccessLoading
);

export const InitAuth = createAction(AuthActionType.AuthInit);

export const InitAuthSet = createAction(
  AuthActionType.AuthInitSet,
  props<{ entity: AuthUserEntityInterface | null }>()
);

// todo move to new state
export const forgotPassword = createAction(
  AuthActionType.ForgotPassword,
  props<{ params: ForgotPasswordInterface }>()
);

export const forgotPasswordSuccess = createAction(
  AuthActionType.ForgotPasswordSuccess
);

export const errorClear = createAction(AuthActionType.errorClear);

export const forgotPasswordFailure = createAction(
  AuthActionType.ForgotPasswordFailure,
  props<{ response: ErrorInterface }>()
);

export const requestSuccess = createAction(
  AuthActionType.RequestSuccess,
  props<{ response: any }>()
);

export const registerLoading = createAction(
  AuthActionType.RegisterLoading,
  props<{ params: RegisterInterface }>()
);

export const registerFailed = createAction(
  AuthActionType.RegisterFailed,
  props<{ response: ErrorInterface }>()
);
export const registerSuccess = createAction(
  AuthActionType.RegisterSuccess,
  props<{ response: any }>()
);
